/* eslint-disable @angular-eslint/directive-selector */
import { Directive, Input, ElementRef, Inject } from '@angular/core';
import { Util } from '../../../../util';
import { APP_BASE_HREF } from '@angular/common';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[appAssetSrc]'
})
export class AssetSrcDirective {
  @Input()
  set appAssetSrc(src: string) {
    this.el.nativeElement.src = Util.prependHost(src, this.baseHref);
  }

  constructor(
    private el: ElementRef,
    @Inject(APP_BASE_HREF) private baseHref: string
  ) { }

}
